import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import AdminLayout from "./layouts/AdminLayout";
import Dashboard from "./pages/admin/Dashboard";
import ChatsPage from "./pages/admin/ChatsPage";
import AgentsPage from "./pages/admin/AgentsPage";
import AddAgentPage from "./pages/admin/AddAgentPage";
import ChannelsPage from "./pages/admin/ChannelsPage";
import CreateChannelPage from "./pages/admin/CreateChannelPage";
import ChannelDetailPage from "./pages/admin/ChannelDetailPage";
import InstallPrompt from "./components/pwa/InstallPrompt";

function App() {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <Routes>
        {/* Redirect root to admin */}
        <Route path="/" element={<Navigate to="/admin" replace />} />

        {/* Admin Routes */}
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="agents" element={<AgentsPage />} />
          <Route path="agents/add" element={<AddAgentPage />} />
          <Route path="channels" element={<ChannelsPage />} />
          <Route path="channels/create" element={<CreateChannelPage />} />
          <Route path="channels/:id" element={<ChannelDetailPage />} />
        </Route>

        {/* Chat Routes with hidden header */}
        <Route path="/admin" element={<AdminLayout hideHeader={true} />}>
          <Route path="chats" element={<ChatsPage />} />
          <Route path="chats/:chatId" element={<ChatsPage />} />
        </Route>
      </Routes>

      {/* PWA Install Prompt */}
      <InstallPrompt />
    </div>
  );
}

export default App;
